// =============================================================================
// STREETSTICKERS — STICKER CONFIGURATOR (Shopify Asset)
// Namespaced under window.SSConfigurator to support multiple sections on page.
// Depends on: pricing.js or pricing-vinyl.js (must be loaded before this file)
//
// Three ways an order goes into the cart (prices always from pricing*.js):
//   * Standard size       -> variant of the main product (SKU EGG-SQ-7-100 …),
//                            quantity 1, real price.
//   * Custom size, square / round / die cut up to 30 cm
//                         -> variant of a hidden size product, priced in steps
//                            (rounded up, see PRICING.CUSTOM_SNAP).
//   * Everything else (custom rectangles, sizes over 30 cm)
//                         -> hidden helper product at 0.01 EUR, quantity = price
//                            in cents ("cents-as-quantity").
// If a variant is missing (e.g. before the variants exist), the helper is used.
// =============================================================================

(function () {
  'use strict';

  window.SSConfigurator = window.SSConfigurator || {};

  const DEFAULT_TEXT = {
    shapes: { square: 'Quadrat', rectangle: 'Rechteck', round: 'Rund', diecut: 'Konturschnitt' },
    fieldSide: 'Seitenlänge', fieldDiameter: 'Durchmesser', fieldLongest: 'Längste Seite', fieldWidth: 'Breite',
    customSize: 'Eigene Größe', standardSizes: 'Standard-Größen', custom: 'custom', longestSide: 'längste Seite',
    pcs: 'Stk', perPcs: '/Stk', topSeller: '★ TOP-SELLER',
    youSave: 'Du sparst', moreSave: 'Mehr bestellen = mehr sparen',
    shippingNote: 'Versand gratis (DE & CH)', pricedAs: 'berechnet als',
    fileTooBig: 'Datei ist zu groß (max. 20 MB). Schick sie uns bitte per Mail.',
    fileFollows: 'Datei folgt', byMail: 'Per Mail — hallo@streetstickers.de',
    askUs: 'Für diese Größe schreib uns an hallo@streetstickers.de – wir richten dir die Bestellung ein.'
  };

  window.SSConfigurator.boot = function (opts) {
    const { sectionId } = opts;
    const T = Object.assign({}, DEFAULT_TEXT, opts.text || {});
    T.shapes = Object.assign({}, DEFAULT_TEXT.shapes, (opts.text && opts.text.shapes) || {});
    const LOCALE = opts.locale || PRICING.LOCALE || 'de-DE';
    PRICING.LOCALE = LOCALE;
    const id = (suffix) => `${suffix}-${sectionId}`;
    const el = (suffix) => document.getElementById(id(suffix));
    const num = (n) => n.toLocaleString(LOCALE);                              // 1.000 / 8,5
    const cm = (n) => (Math.round(n * 10) / 10).toLocaleString(LOCALE);
    const dec1 = (n) => n.toLocaleString(LOCALE, { minimumFractionDigits: 1, maximumFractionDigits: 1 });

    // ----- STATE -----
    const defShape = (opts.defaultShape && PRICING.SHAPES[opts.defaultShape]) ? opts.defaultShape : 'square';
    const defSize = PRICING.SHAPES[defShape].sizes.find(sz => sz.id === opts.defaultSizeId) || PRICING.SHAPES[defShape].sizes[0];
    const defQty = PRICING.QUANTITY_TIERS.some(t => t.qty === opts.defaultQty) ? opts.defaultQty : PRICING.QUANTITY_TIERS[0].qty;
    const STATE = {
      shape: defShape, sizeId: defSize.id, sizeW: defSize.w, sizeH: defSize.h,
      isCustom: false, qty: defQty,
      artworkMode: 'upload', uploadedFile: null, emailLater: false, canOrder: true
    };

    // Square, round (diameter) and die cut (longest side) take one size value.
    const oneSide = shape => shape !== 'rectangle';
    const fieldLabel = shape => shape === 'round' ? T.fieldDiameter : (shape === 'diecut' ? T.fieldLongest : (shape === 'square' ? T.fieldSide : T.fieldWidth));
    const shapeLabel = shape => T.shapes[shape] || PRICING.SHAPES[shape].label;
    const sizeText = (shape, w, h) => shape === 'round' ? `Ø ${cm(w)} cm` : (shape === 'diecut' ? `${cm(w)} cm` : `${cm(w)} × ${cm(h)} cm`);

    // ----- DOM refs -----
    const els = {
      sizeGrid: el('SSSizeGrid'), sizeHint: el('SSSizeHint'), qtyGrid: el('SSQtyGrid'),
      customW: el('SSCustomW'), customH: el('SSCustomH'), customApply: el('SSCustomApply'),
      customFields: el('SSCustomFields'), customHField: el('SSCustomHField'),
      perUnit: el('SSPerUnit'), total: el('SSTotal'), ctaPrice: el('SSCtaPrice'),
      savingsBadge: el('SSSavings'), savingsPct: el('SSSavingsPct'), savingsAbs: el('SSSavingsAbs'),
      breakdown: el('SSBreakdown'), minNote: el('SSMinNote'),
      propForm: el('SSPropForm'), propSize: el('SSPropSize'), propArea: el('SSPropArea'),
      propQty: el('SSPropQty'), propPerUnit: el('SSPropPerUnit'), propArtwork: el('SSPropArtwork'),
      propPriceCents: el('SSPropPriceCents'), propConfigJson: el('SSPropConfigJson'),
      propShape: el('SSPropShape'), propExact: el('SSPropExact'), cartQty: el('SSCartQuantity'),
      uploadInput: el('SSUploadInput'), uploadLabel: el('SSUploadLabel'), uploadFile: el('SSUploadFile'),
      uploadFileName: el('SSUploadFileName'), uploadFileClear: el('SSUploadFileClear'),
      panelUpload: el('SSPanelUpload'), panelEmail: el('SSPanelEmail'), emailLater: el('SSEmailLater'),
      pricetableGrid: el('SSPricetableGrid'), pricetableShape: el('SSPricetableShape'),
      stickyCta: el('SSStickyCta'), stickyBreakdown: el('SSStickyBreakdown'),
      stickyPrice: el('SSStickyPrice'), stickyPer: el('SSStickyPer'), mainCta: el('SSAddToCart'),
      galleryVideo: el('SSGalleryVideo'), galleryVideoToggle: el('SSGalleryVideoToggle'), galleryShapeImgs: el('SSShapeImgs'),
      form: document.getElementById(`SSConfigForm-${sectionId}`)
    };
    els.variantId = els.form ? els.form.querySelector('input[name="id"]') : null;

    // ----- VARIANT DATA (from Liquid, keyed by SKU) -----
    let VDATA = { customVariantId: null, variants: {}, sizeVariants: {} };
    try {
      const node = document.getElementById(`SSVariantData-${sectionId}`);
      if (node) VDATA = Object.assign(VDATA, JSON.parse(node.textContent));
    } catch (e) { /* keep defaults */ }
    const findVariant = sku => (VDATA.variants && VDATA.variants[sku]) || (VDATA.sizeVariants && VDATA.sizeVariants[sku]) || null;

    // Price quote for the current shape/size at a given quantity.
    function quote(qty) {
      const area = calcArea(STATE.shape, STATE.sizeW, STATE.sizeH);
      const engine = (w, h) => priceFor(calcArea(STATE.shape, w, h), qty, STATE.shape);
      let priceSize = null, sku = null;
      if (!STATE.isCustom) sku = skuFor(STATE.shape, STATE.sizeW, STATE.sizeH, qty);
      else if (oneSide(STATE.shape)) {
        priceSize = snapSize(STATE.sizeW);
        if (priceSize) sku = skuFor(STATE.shape, priceSize, priceSize, qty);
      }
      const v = sku ? findVariant(sku) : null;
      const p = priceSize ? engine(priceSize, priceSize) : engine(STATE.sizeW, STATE.sizeH);
      if (v) {
        const total = v.price / 100;
        return { total, perUnit: total / qty, variantId: v.id, sku, minimumApplied: p.floorActive, priceSize, area };
      }
      return { total: p.total, perUnit: p.discountedPerUnit, variantId: null, sku: null, minimumApplied: p.floorActive, priceSize, area };
    }
    function savings(qty) {
      const base = quote(PRICING.QUANTITY_TIERS[0].qty), cur = quote(qty);
      const pct = base.perUnit > 0 && cur.perUnit < base.perUnit ? (1 - cur.perUnit / base.perUnit) * 100 : 0;
      return { pct, abs: Math.max(0, base.perUnit * qty - cur.total) };
    }

    // ----- STICKY CTA (moved to <body>; visible when the main CTA is off-screen) -----
    if (els.stickyCta && els.stickyCta.parentNode !== document.body) document.body.appendChild(els.stickyCta);
    if (els.stickyCta && els.mainCta && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => entries.forEach(entry => {
        els.stickyCta.classList.toggle('is-visible', !entry.isIntersecting);
        els.stickyCta.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      }), { threshold: 0.05, rootMargin: '0px 0px -60px 0px' });
      io.observe(els.mainCta);
    }

    // ----- GALLERY VIDEO TOGGLE -----
    if (els.galleryVideo && els.galleryVideoToggle && els.galleryShapeImgs) {
      els.galleryVideoToggle.addEventListener('click', () => {
        const show = els.galleryVideo.hasAttribute('hidden');
        const v = els.galleryVideo.querySelector('video');
        els.galleryVideo.hidden = !show;
        els.galleryShapeImgs.style.visibility = show ? 'hidden' : '';
        els.galleryVideoToggle.setAttribute('aria-pressed', show ? 'true' : 'false');
        if (v) { if (show && typeof v.play === 'function') v.play().catch(() => {}); if (!show && typeof v.pause === 'function') v.pause(); }
      });
    }

    // ----- SHAPES -----
    const section = document.getElementById(`ProductConfigurator-${sectionId}`);
    section.querySelectorAll('.ss-shape').forEach(btn => btn.addEventListener('click', () => selectShape(btn.dataset.shape)));

    function setShapeUi(shape) {
      section.querySelectorAll('.ss-shape').forEach(btn => btn.setAttribute('aria-checked', btn.dataset.shape === shape ? 'true' : 'false'));
      section.querySelectorAll('[data-shape-img]').forEach(img => { img.hidden = img.dataset.shapeImg !== shape; });
      els.customFields.classList.toggle('is-round', oneSide(shape));
      const lbl = els.customFields.querySelector('.ss-custom-size__field-label');
      if (lbl) lbl.textContent = fieldLabel(shape);
    }
    function selectShape(shape) {
      STATE.shape = shape;
      if (!STATE.isCustom) {
        const first = PRICING.SHAPES[shape].sizes[0];
        STATE.sizeId = first.id; STATE.sizeW = first.w; STATE.sizeH = first.h;
      }
      if (oneSide(shape) && STATE.isCustom) STATE.sizeH = STATE.sizeW;
      setShapeUi(shape);
      renderSizes(); renderAll();
    }

    // ----- SIZES -----
    function renderSizes() {
      section.querySelectorAll('.ss-size-note[data-shape]').forEach(n => { n.hidden = n.dataset.shape !== STATE.shape; });
      els.sizeGrid.innerHTML = '';
      PRICING.SHAPES[STATE.shape].sizes.forEach(size => {
        const area = calcArea(STATE.shape, size.w, size.h);
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'ss-size';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', !STATE.isCustom && STATE.sizeId === size.id ? 'true' : 'false');
        const sub = STATE.shape === 'diecut' ? T.longestSide : `${area.toFixed(0)} cm²`;
        btn.innerHTML = `<span class="ss-size__label">${sizeText(STATE.shape, size.w, size.h)}</span><span class="ss-size__area">${sub}</span>`;
        btn.addEventListener('click', () => { STATE.isCustom = false; STATE.sizeId = size.id; STATE.sizeW = size.w; STATE.sizeH = size.h; renderSizes(); renderAll(); });
        els.sizeGrid.appendChild(btn);
      });
      if (STATE.isCustom) {
        const area = calcArea(STATE.shape, STATE.sizeW, STATE.sizeH);
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'ss-size ss-size--custom';
        btn.setAttribute('aria-checked', 'true'); btn.setAttribute('role', 'radio');
        const sub = STATE.shape === 'diecut' ? T.longestSide : `${area.toFixed(0)} cm²`;
        btn.innerHTML = `<span class="ss-size__label">${sizeText(STATE.shape, STATE.sizeW, STATE.sizeH)}</span><span class="ss-size__area">${sub} · ${T.custom}</span>`;
        els.sizeGrid.appendChild(btn);
      }
      if (els.sizeHint) els.sizeHint.textContent = STATE.isCustom ? T.customSize : T.standardSizes;
    }

    // ----- CUSTOM SIZE -----
    els.customApply.addEventListener('click', applyCustom);
    [els.customW, els.customH].forEach(inp => {
      inp.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); applyCustom(); } });
      inp.addEventListener('input', () => inp.classList.remove('is-invalid'));
    });
    const parseCm = v => parseFloat(String(v).replace(',', '.'));
    function applyCustom() {
      const min = PRICING.CUSTOM_MIN_CM, max = PRICING.CUSTOM_MAX_CM;
      const w = parseCm(els.customW.value);
      const h = oneSide(STATE.shape) ? w : parseCm(els.customH.value);
      let valid = true;
      if (!Number.isFinite(w) || w < min || w > max) { els.customW.classList.add('is-invalid'); valid = false; }
      if (!oneSide(STATE.shape) && (!Number.isFinite(h) || h < min || h > max)) { els.customH.classList.add('is-invalid'); valid = false; }
      if (!valid) return;
      const rw = Math.round(w * 10) / 10, rh = Math.round(h * 10) / 10;
      const std = PRICING.SHAPES[STATE.shape].sizes.find(sz => sz.w === rw && sz.h === rh);
      if (std) { STATE.isCustom = false; STATE.sizeId = std.id; }
      else { STATE.isCustom = true; STATE.sizeId = 'custom'; }
      STATE.sizeW = rw; STATE.sizeH = rh;
      renderSizes(); renderAll();
      const det = els.customApply.closest('details');
      if (det) det.open = false;
    }

    // ----- QTY -----
    function renderQty() {
      els.qtyGrid.innerHTML = '';
      PRICING.QUANTITY_TIERS.forEach(tier => {
        const q = quote(tier.qty);
        const disc = typeof discountFor === 'function' ? discountFor(STATE.shape, tier.qty) : tier.discount;
        const pct = Math.round(disc * 100);
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'ss-qty';
        btn.setAttribute('role', 'radio'); btn.setAttribute('aria-checked', STATE.qty === tier.qty ? 'true' : 'false');
        btn.innerHTML = `
          <span class="ss-qty__discount ${disc === 0 ? 'ss-qty__discount--zero' : ''}">−${pct}%</span>
          <span class="ss-qty__count">${num(tier.qty)}<span class="ss-qty__count-suffix">${T.pcs}</span></span>
          <span class="ss-qty__per">${fmtEURcents(q.perUnit)}${T.perPcs}</span>
          ${tier.qty === PRICING.POPULAR_QTY ? `<span class="ss-qty__best">${T.topSeller}</span>` : ''}
        `;
        btn.addEventListener('click', () => { STATE.qty = tier.qty; renderAll(); });
        els.qtyGrid.appendChild(btn);
      });
    }

    // ----- ARTWORK -----
    section.querySelectorAll('.ss-artwork-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        const mode = tab.dataset.tab;
        STATE.artworkMode = mode;
        section.querySelectorAll('.ss-artwork-tab').forEach(t => {
          const a = t.dataset.tab === mode;
          t.classList.toggle('ss-artwork-tab--active', a);
          t.setAttribute('aria-selected', a ? 'true' : 'false');
        });
        els.panelUpload.hidden = mode !== 'upload';
        els.panelEmail.hidden = mode !== 'email';
      });
    });
    els.uploadInput.addEventListener('change', e => {
      const file = e.target.files[0]; if (!file) return;
      // Shopify-Limit 20 MiB, Reserve für die ZIP-Hülle (upload-original.js)
      if (file.size > 20 * 1024 * 1024 - 4096) { alert(T.fileTooBig); els.uploadInput.value = ''; return; }
      STATE.uploadedFile = file;
      els.uploadFileName.textContent = `${file.name} · ${(file.size / 1024 / 1024).toFixed(2)} MB`;
      els.uploadFile.hidden = false;
    });
    els.uploadFileClear.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      STATE.uploadedFile = null; els.uploadInput.value = ''; els.uploadFile.hidden = true;
    });
    ['dragenter', 'dragover'].forEach(ev => els.uploadLabel.addEventListener(ev, e => { e.preventDefault(); els.uploadLabel.classList.add('is-drag'); }));
    ['dragleave', 'drop'].forEach(ev => els.uploadLabel.addEventListener(ev, e => { e.preventDefault(); els.uploadLabel.classList.remove('is-drag'); }));
    els.uploadLabel.addEventListener('drop', e => {
      e.preventDefault();
      const f = e.dataTransfer.files[0];
      if (f) { els.uploadInput.files = e.dataTransfer.files; els.uploadInput.dispatchEvent(new Event('change')); }
    });
    els.emailLater.addEventListener('change', e => { STATE.emailLater = e.target.checked; });

    // ----- PRICE + CART FIELDS -----
    function renderPrice() {
      const q = quote(STATE.qty);
      const s = savings(STATE.qty);
      const useVariant = !!q.variantId;
      const canOrder = useVariant || !!VDATA.customVariantId;
      STATE.canOrder = canOrder;
      const sizeStr = sizeText(STATE.shape, STATE.sizeW, STATE.sizeH);
      const shapeName = shapeLabel(STATE.shape);
      const pricedAs = STATE.isCustom && q.priceSize && Math.abs(q.priceSize - STATE.sizeW) > 0.001;
      const pricedAsTxt = pricedAs ? ` (${T.pricedAs} ${sizeText(STATE.shape, q.priceSize, q.priceSize)})` : '';
      const areaTxt = STATE.shape === 'diecut' ? T.longestSide : `${dec1(q.area)} cm²`;

      els.perUnit.textContent = fmtEURcents(q.perUnit);
      els.total.textContent = fmtEUR(q.total);
      els.ctaPrice.textContent = fmtEUR(q.total);
      els.breakdown.textContent = canOrder
        ? `${num(STATE.qty)} × ${shapeName} ${sizeStr}${pricedAsTxt} · ${areaTxt} · ${fmtEURcents(q.perUnit)}${T.perPcs} · ${T.shippingNote}`
        : T.askUs;
      if (els.mainCta) els.mainCta.disabled = !canOrder;
      const stickyBtn = els.stickyCta ? els.stickyCta.querySelector('button') : null;
      if (stickyBtn) stickyBtn.disabled = !canOrder;
      if (els.stickyPrice) els.stickyPrice.textContent = fmtEUR(q.total);
      if (els.stickyPer) els.stickyPer.textContent = `${fmtEURcents(q.perUnit)}${T.perPcs}`;
      if (els.stickyBreakdown) els.stickyBreakdown.textContent = `${num(STATE.qty)} × ${shapeName} ${sizeStr}`;
      if (els.minNote) els.minNote.hidden = !q.minimumApplied;

      if (s.abs > 0.01 && STATE.qty > PRICING.QUANTITY_TIERS[0].qty) {
        els.savingsBadge.classList.remove('is-zero');
        els.savingsPct.textContent = `−${Math.round(s.pct)}%`;
        els.savingsAbs.textContent = `${T.youSave} ${fmtEUR(s.abs)}`;
      } else {
        els.savingsBadge.classList.add('is-zero');
        els.savingsPct.textContent = '−0%';
        els.savingsAbs.textContent = T.moreSave;
      }
      els.total.classList.remove('ss-price-flash'); void els.total.offsetWidth; els.total.classList.add('ss-price-flash');

      // Variant: quantity 1, shape/size/qty are in the variant title.
      // Helper: 0.01 EUR x cents, configuration in the line properties.
      const totalCents = Math.round(q.total * 100);
      if (els.variantId && (useVariant || VDATA.customVariantId)) els.variantId.value = useVariant ? q.variantId : VDATA.customVariantId;
      if (els.cartQty) els.cartQty.value = useVariant ? 1 : totalCents;
      [els.propForm, els.propSize, els.propArea, els.propQty, els.propPerUnit, els.propPriceCents].forEach(inp => { if (inp) inp.disabled = useVariant; });
      if (els.propExact) { els.propExact.disabled = !(useVariant && pricedAs); els.propExact.value = pricedAs ? sizeStr : ''; }
      if (els.propForm) els.propForm.value = shapeName;
      if (els.propSize) els.propSize.value = sizeStr;
      if (els.propArea) els.propArea.value = `${dec1(q.area)} cm²`;
      if (els.propQty) els.propQty.value = String(STATE.qty);
      if (els.propPerUnit) els.propPerUnit.value = fmtEURcents(q.perUnit);
      if (els.propPriceCents) els.propPriceCents.value = String(totalCents);
      if (els.propShape) els.propShape.value = STATE.shape;
      if (els.propConfigJson) els.propConfigJson.value = JSON.stringify({
        shape: STATE.shape, sizeW: STATE.sizeW, sizeH: STATE.sizeH, qty: STATE.qty,
        totalEUR: q.total, sku: q.sku, priceSize: q.priceSize || null
      });
    }

    // ----- PRICE TABLE -----
    function renderPriceTable() {
      if (els.pricetableShape) els.pricetableShape.textContent = `${sizeText(STATE.shape, STATE.sizeW, STATE.sizeH)} ${shapeLabel(STATE.shape)}`;
      if (!els.pricetableGrid) return;
      els.pricetableGrid.innerHTML = '';
      PRICING.QUANTITY_TIERS.forEach(tier => {
        const q = quote(tier.qty);
        const disc = typeof discountFor === 'function' ? discountFor(STATE.shape, tier.qty) : tier.discount;
        const pct = Math.round(disc * 100);
        const cell = document.createElement('div');
        cell.className = 'ss-pricetable__cell' + (tier.qty === STATE.qty ? ' ss-pricetable__cell--active' : '');
        cell.innerHTML = `${disc > 0 ? `<span class="ss-pricetable__cell-discount">−${pct}%</span>` : ''}<span class="ss-pricetable__cell-qty">${num(tier.qty)}</span><span class="ss-pricetable__cell-per">${fmtEURcents(q.perUnit)}${T.perPcs}</span><span class="ss-pricetable__cell-total">${fmtEUR(q.total)}</span>`;
        cell.addEventListener('click', () => { STATE.qty = tier.qty; renderAll(); });
        els.pricetableGrid.appendChild(cell);
      });
    }

    // ----- FORM SUBMIT: artwork property -----
    if (els.form) {
      els.form.addEventListener('submit', e => {
        if (STATE.canOrder === false) { e.preventDefault(); return; }
        if (els.propArtwork) els.propArtwork.value = STATE.artworkMode === 'upload'
          ? (STATE.uploadedFile ? STATE.uploadedFile.name : T.fileFollows) : T.byMail;
      });
    }

    function renderAll() { renderQty(); renderPrice(); renderPriceTable(); }

    // ----- INIT: optional preselection from the URL -----
    //   ?variant=123 (Google Shopping, cart "Bearbeiten" links)
    //   ?shape=round&w=9&h=9&qty=250 (size products, links)
    (function applyUrlPreset() {
      let params;
      try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
      const variantParam = params.get('variant');
      if (variantParam) {
        const all = Object.assign({}, VDATA.variants || {}, VDATA.sizeVariants || {});
        const sku = Object.keys(all).find(k => String(all[k].id) === variantParam);
        const m = sku && sku.match(/^[A-Z]+-([A-Z]+)-([0-9.]+)(?:x([0-9.]+))?-(\d+)$/);
        if (m) {
          const shapeId = Object.keys(PRICING.SHAPE_CODE).find(k => PRICING.SHAPE_CODE[k] === m[1]);
          if (shapeId) { params.set('shape', shapeId); params.set('w', m[2]); params.set('h', m[3] || m[2]); params.set('qty', m[4]); }
        }
      }
      const shape = params.get('shape');
      if (shape && PRICING.SHAPES[shape]) {
        STATE.shape = shape;
        const first = PRICING.SHAPES[shape].sizes[0];
        STATE.sizeId = first.id; STATE.sizeW = first.w; STATE.sizeH = first.h;
      }
      const w = parseCm(params.get('w'));
      const h = oneSide(STATE.shape) ? w : parseCm(params.get('h'));
      if (Number.isFinite(w) && Number.isFinite(h) &&
          w >= PRICING.CUSTOM_MIN_CM && w <= PRICING.CUSTOM_MAX_CM && h >= PRICING.CUSTOM_MIN_CM && h <= PRICING.CUSTOM_MAX_CM) {
        const std = PRICING.SHAPES[STATE.shape].sizes.find(sz => sz.w === w && sz.h === h);
        if (std) { STATE.isCustom = false; STATE.sizeId = std.id; STATE.sizeW = std.w; STATE.sizeH = std.h; }
        else { STATE.isCustom = true; STATE.sizeId = 'custom'; STATE.sizeW = w; STATE.sizeH = h; }
      }
      const qty = parseInt(params.get('qty'), 10);
      if (PRICING.QUANTITY_TIERS.some(t => t.qty === qty)) STATE.qty = qty;
    })();

    setShapeUi(STATE.shape);
    renderSizes(); renderAll();
  };

})();
